import {shallowRef} from 'vue';
import {defineStore} from 'pinia';

export const useBannersStore = defineStore('banners', () => {
    const disableVideoInBanners = shallowRef(false);

    function setDisableVideoInBanners(bool) {
        disableVideoInBanners.value = bool;
    }

    return {
        disableVideoInBanners,
        setDisableVideoInBanners,
    };
});
